import styled, { css } from 'styled-components';
import arrowDown from '~/assets/icons/arrow_down.svg';
import { TextLabel } from '../TextLabel';

const StyledContainer = styled.div`
	position: relative;
`;

const StyledSelectTopContainer = styled.div<{
	$active?: boolean;
	$open?: boolean;
	$icon: string;
}>`
	display: flex;
	align-items: center;
	height: 40px;
	padding: 0 10px;
	border-radius: 10px;
	background-color: ${(props) =>
		props.$open
			? '#ffffff'
			: props.$active
			? '#2D70DA'
			: 'rgba(255, 255, 255, 0.02)'};
	${({ $active, $open }) =>
		!$active &&
		!$open &&
		css`
			border: 1px solid rgba(255, 255, 255, 0.1);
		`}
	transition: background-color 0.3s ease;
	cursor: pointer;

	.icon {
		width: 14px;
		height: 14px;
		background-image: url(${(props) => props.$icon});
		background-repeat: no-repeat;
		background-position: center;
		background-size: contain;
		filter: invert(${(props) => (props.$open ? 1 : 0)});
		opacity: ${(props) => (props.$active ? 1 : 0.5)};
		transition:
			filter 0.3s ease,
			opacity 0.3s ease;
	}

	${TextLabel} {
		margin-left: 10px;
		font-size: 14px;
		color: ${(props) =>
			props.$open
				? '#000000'
				: props.$active
				? '#FFFFFF'
				: 'rgba(255,255,255,0.5)'};
		transition: color 0.3s ease;
	}

	.arrow {
		width: 13px;
		height: 10px;
		margin-left: auto;
		background-image: url(${arrowDown});
		background-repeat: no-repeat;
		background-position: center;
		background-size: contain;
		filter: invert(${(props) => (props.$open ? 1 : 0)});
		rotate: ${(props) => (props.$open ? '180deg' : '0deg')};
		opacity: ${(props) => (props.$active ? 1 : 0.5)};
		transition:
			filter 0.3s ease,
			rotate 0.3s ease,
			opacity 0.3s ease;
	}

	&:hover {
		background-color: #ffffff;

		.icon {
			filter: invert(1);
			opacity: 1;
		}

		${TextLabel} {
			color: #000000;
		}

		.arrow {
			filter: invert(1);
			opacity: 1;
		}
	}
`;

const StyledListContainer = styled.div<{ $top?: boolean }>`
	position: absolute;
	width: 100%;
	border-radius: 10px;
	overflow: hidden;
	z-index: 20;
	background-color: rgba(255, 255, 255, 0.95);
	opacity: 0;
	transition: opacity 0.4s ease;

	${(props) =>
		props.$top
			? css`
					bottom: 50px;
			  `
			: css`
					top: 50px;
			  `}

	&.list-enter {
		opacity: 0;
	}

	&.list-enter-active,
	&.list-enter-done,
	&.list-exit {
		opacity: 1;
	}

	&.list-exit-active {
		opacity: 0;
	}
`;

const StyledDivider = styled.div`
	height: 1px;
	margin: 0 20px;
	background-color: rgba(0, 0, 0, 0.1);
`;

const StyledItem = styled.div`
	display: flex;
	align-items: center;
	width: 100%;
	height: 58px;
	padding: 20px 0;
	transition: background-color 0.3s ease;
	border-bottom: 1px solid rgba(0, 0, 0, 0.1);
	cursor: pointer;

	${TextLabel} {
		font-size: 14px;
		color: #000000;
		transition: color 0.3s ease;
	}
`;

const StyledSelectItemWrapper = styled.div<{
	$disabled?: boolean;
	$scrollbar?: boolean;
	$active?: boolean;
}>`
	padding: ${(props) => (props.$scrollbar ? '0 10px 0 20px' : '0 20px')};
	background-color: transparent;
	transition: background-color 0.3s ease;

	${(props) =>
		props.$active &&
		css`
			background-color: #2d70da;

			${StyledItem} {
				${TextLabel} {
					color: #ffffff;
				}
			}
		`}

	${(props) =>
		!props.$disabled &&
		css`
			&:hover {
				background-color: #000000;

				${StyledItem} {
					${TextLabel} {
						color: #ffffff;
					}
				}
			}
		`}

	${(props) =>
		!props.$disabled &&
		css`
			&,
			& * {
				cursor: pointer;
			}
		`}
`;

const StyledDropdownContainer = styled.div`
	position: absolute;
	top: calc(100% + 10px);
	width: 100%;
	z-index: 4;
	opacity: 0;
	transition: opacity 0.3s ease;

	&.results-enter {
		opacity: 0;
	}

	&.results-enter-active,
	&.results-enter-done,
	&.results-exit {
		opacity: 1;
	}

	&.results-exit-active {
		opacity: 0;
	}
`;

export {
	StyledContainer,
	StyledDivider,
	StyledDropdownContainer,
	StyledItem,
	StyledListContainer,
	StyledSelectItemWrapper,
	StyledSelectTopContainer,
};
